<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https" /> {{ caption }}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()"
            v-if="permissions && permissions['suppliers.write'] === true">Nuevo Vendedor</CButton>
          <CButton color="success" size="sm" @click="importModal()"
            v-if="permissions && permissions['suppliers.write'] === true">Importar Vendedores</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <div role="group" class="form-group manager_filter" style="float: right; margin: 0px 0px 0px; font-size: 12px;">
        <CSelect :value.sync="managerSelected" :options="managersOptions" @change="changeFilters"
          style="font-size: 10px;" />
      </div>
      <CDataTable :tableFilter="tableFilter" :hover="hover" :striped="striped" :border="border" :small="small"
        :fixed="fixed" :items="items" :fields="fields" :items-per-page="30" :dark="dark" pagination
        class="suppliers_table">
        <template #position="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.position }}</td>
        </template>
        <template #code="{ item }">
          <td class="text-center" style="font-size: 12px;">{{ item.code }}</td>
        </template>
        <template #name="{ item }">
          <td style="font-size: 12px;">{{ item.name }}</td>
        </template>
        <template #wallet="{ item }">
          <td class="text-center" style="font-size: 12px;">
            {{ (item.wallet) ? item.wallet : '-' }}
          </td>
        </template>
        <template #stock="{ item }">
          <td class="text-center" style="font-size: 12px;">
            {{ (item.stock) ? item.stock : '-' }}
          </td>
        </template>
        <template #manager_id="{ item }">
          <td class="text-center w300" style="font-size: 12px;">
            {{ item.manager_id > 0 && item.manager && item.manager.name ? item.manager.code + " - " + item.manager.name : '-' }}
          </td>
        </template>
        <template #user="{ item }">
          <td class="text-center w200" style="font-size: 12px;">
            {{ item.user && item.user.email ? item.user.email : '-' }}
            <span v-if="item.user && item.user.api_token">
              <br />{{ item.user.last_login | date }}
              <span v-if="permissions && permissions['suppliers.login'] === true">
                <br />
                <CButton color="success" size="sm" @click="login(item)">
                  <CIcon name="cil-https" /> Ingresar
                </CButton>
              </span>
            </span>
          </td>
        </template>
        <template #actions="{ item }">
          <td class="table_actions b4" style="width:150px !important;">
            <CButton color="info" size="sm" @click="showSales(item)">
              <CIcon name="cil-zoom" /> Ventas
            </CButton><br />
            <CButton color="warning" size="sm" @click="updateModal(item)"
              v-if="permissions && permissions['suppliers.write'] === true">
              <CIcon name="cil-pencil" />
            </CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"
              v-if="permissions && permissions['suppliers.write'] === true">
              <CIcon name="cil-trash" />
            </CButton>
            <CButton color="success" size="sm" @click="upgradeModal(item.id)"
              v-if="permissions && permissions['suppliers.write'] === true">
              <CIcon name="cil-user-follow" />
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <SupplierModal ref="supplierModal" :managers="managers" @store="storeProcess" @update="updateProcess">
    </SupplierModal>
    <UpgradeModal ref="upgradeModal" @upgrade="upgradeProcess"></UpgradeModal>
    <ImportSuppliersModal ref="importModal" @import="importProcess"></ImportSuppliersModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import SupplierModal from './SupplierModal.vue'
import UpgradeModal from './UpgradeModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ImportSuppliersModal from './ImportSuppliersModal.vue'
import ws from '../../services/suppliers';
import ws_managers from '../../services/managers';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'SuppliersTable',
  components: { SupplierModal, DeleteModal, UpgradeModal, ImportSuppliersModal },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default() {
        return [
          { key: 'position', label: '#', _style: 'font-size: 12px; width: 50px;' },
          { key: 'code', label: 'Ruta', _style: 'font-size: 12px; width: 80px;' },
          { key: 'name', label: 'Nombre', _style: 'font-size: 12px; width: 230px;' },
          { key: 'manager_id', label: 'Supervisor', _style: 'font-size: 12px;' },
          { key: 'wallet', label: 'Monedero', _style: 'font-size: 12px; width: 100px;' },
          { key: 'stock', label: 'Stock', _style: 'font-size: 12px; width: 100px;' },
          { key: 'user', label: 'Acceso', _style: 'font-size: 12px;' },
          { key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size: 12px; width: 150px !important;' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      supplier_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      },
      managers: [],
      managersOptions: [],
      managerSelected: "",
    }
  },
  mounted: async function () {
    let response = await ws_managers.get();

    if (response.type == "success") {
      this.managers = response.data;

      this.managersOptions = await this.$parseSelectOptionsOrdered(this.managers, "id", "display_name", [{ value: '0', label: 'Todos los Supervisores' }]);
    }
  },
  methods: {
    async changeFilters() {
      this.loading();

      let response = await ws.getByManager(this.managerSelected);

      if (response.type == "success") {
        this.$emit("filtered", response.data);
      }

      this.loaded();
    },
    getFilters() {
      let filters = {
        provider: this.providerSelected
      };

      return filters;
    },
    showSales(item) {
      router.push({ path: '/suppliers/' + item.id + '/' + (this.slugify(item.name)) + '/sales' });
    },
    storeModal() {
      this.$refs.supplierModal.storeModal();
    },
    updateModal(item) {
      this.$refs.supplierModal.updateModal(item);
    },
    deleteModal(item) {
      this.$refs.deleteModal.show("Eliminar Vendedor", item.id, item.name);
    },
    upgradeModal(supplier_id) {
      this.$refs.upgradeModal.upgradeModal(supplier_id);
    },
    login(item) {
      if (!item.user || !item.user.api_token) {
        this.showToast('warning', 'Este vendedor no tiene usuario asignado.');
        return;
      }

      this.$router.push({
        name: 'LoginLink',
        params: {
          code: item.user.api_token
        }
      });
    },
    async storeProcess(data) {
      let response = await ws.store(data);

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({ id: id });

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    async upgradeProcess(data) {
      let response = await ws.upgrade(data);

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    importModal() {
      this.$refs.importModal.importModal();
    },
    async importProcess(data) {
      this.$emit("refresh", data);
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
<style>
.suppliers_table td {
  font-size: 12px;
  padding: 5px 8px !important;
}
</style>
